module.exports = __webpack_public_path__ + "media/home2-left.1bed64ca.mp4";